"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var fromActionSocket = function fromActionSocket(actionsSocket) {
  return _rxjs.Observable.create(function (observer) {
    actionsSocket.disconnect$.subscribe(observer.next.bind(observer));
    actionsSocket.on(function (actions) {
      return actions instanceof Array ? actions.forEach(observer.next.bind(observer)) : observer.next(actions);
    });
  });
};

var _default = fromActionSocket;
exports["default"] = _default;